<template lang="pug">
  router-view
</template>
<script>
export default {
  name: 'prepStation'
}
</script>
<style lang="scss" scoped>
</style>
